var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 139,
    viewBox: "0 0 115 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 57,
    y1: 18.5,
    x2: 57,
    y2: 1,
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 57,
    y1: 137.5,
    x2: 57,
    y2: 120,
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 71,
    x2: 18.5,
    y2: 71,
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 7.18598,
    y1: 119.454,
    x2: 21.0802,
    y2: 108.814,
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 5.40289,
    y1: 21.5616,
    x2: 19.241,
    y2: 32.2741,
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 18.5,
    y2: -1,
    transform: "matrix(-1 0 0 1 114.5 72)",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 18.5,
    y2: -1,
    transform: "matrix(-0.793956 -0.607976 -0.607976 0.793956 107.5 120.855)",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 18.5,
    y2: -1,
    transform: "matrix(-0.79075 0.61214 0.61214 0.79075 110.5 21.7402)",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 30.5L33 33V98.5V106L41 108.5L52 109.5L75 108.5L81 106V32.5L80 30.5L75 28.5H69H41L36 30.5Z",
    fill: "#F5DADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.587 27.0669C61.9141 27.1731 66.6014 27.2641 71.2837 27.4866C73.5338 27.5928 75.7688 27.9315 78.0088 28.1793C78.3414 28.1913 78.6653 28.2888 78.9493 28.4625C80.8707 29.944 82.7568 31.3345 82.7517 34.2369C82.718 56.6741 82.7281 79.1095 82.7821 101.543C82.7618 101.904 82.7618 102.265 82.7821 102.625C83.1461 105.77 81.5281 107.571 78.7875 108.693C76.3427 109.642 73.7576 110.181 71.1371 110.286C65.9492 110.594 60.7562 110.852 55.5582 110.918C50.2683 111.013 44.9792 110.685 39.7416 109.937C37.4459 109.603 35.2382 108.822 33.2441 107.636C32.573 107.255 32.0221 106.693 31.6539 106.015C31.2857 105.337 31.1149 104.569 31.1608 103.798C31.1608 99.4162 31.1709 95.0339 31.1912 90.6517C31.1912 75.0677 31.1912 59.4838 31.1912 43.8998C31.1912 40.8406 31.1558 37.7815 31.1355 34.7224C31.1086 33.8094 31.2806 32.9015 31.6394 32.0615C31.9983 31.2216 32.5355 30.4697 33.2137 29.8581C34.584 28.4928 36.0454 28.1743 37.7645 27.9619C44.2418 27.168 50.7343 27.163 58.587 27.0669ZM33.507 43.6975V44.6633C33.4868 51.2401 33.4683 57.8286 33.4514 64.429C33.4278 76.9386 33.4076 89.4482 33.3907 101.958C33.3907 105.371 33.0165 105.336 36.9302 106.913C39.7012 108.026 42.6794 108.122 45.6121 108.324C54.3075 108.976 63.0434 108.861 71.7186 107.98C74.2872 107.707 76.8458 107.338 79.1465 105.998C79.5725 105.775 79.9262 105.436 80.1663 105.02C80.4063 104.603 80.5226 104.127 80.5016 103.647C80.5016 84.0682 80.5151 64.4896 80.5421 44.9111C80.5421 44.5925 80.5168 44.274 80.4965 43.8492C64.8898 45.7827 49.101 45.7317 33.507 43.6975V43.6975ZM33.507 41.412C49.0951 43.4875 64.8865 43.5333 80.4864 41.5485C80.4864 39.7889 80.4864 38.1405 80.4864 36.4921C80.4864 35.5263 80.4864 34.5656 80.451 33.6049C80.4005 32.5228 79.824 31.9211 79.0403 32.0879C70.5305 33.6731 61.8733 34.3258 53.2221 34.0347C47.3036 33.8255 41.4094 33.168 35.5903 32.0677C34.1644 31.7997 33.6081 32.1638 33.5424 33.5088C33.416 36.1129 33.507 38.7271 33.507 41.4019V41.412ZM75.7182 30.1968C63.3745 29.0996 50.9578 29.0996 38.614 30.1968C50.8905 32.3256 63.4417 32.3256 75.7182 30.1968V30.1968Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6374 68.7725C45.2904 68.8639 44.9245 68.8539 44.583 68.7437C44.2416 68.6335 43.9389 68.4276 43.7109 68.1506C43.4759 67.8718 43.1699 67.6617 42.8254 67.5426C42.4808 67.4235 42.1104 67.3997 41.7534 67.4738C41.3965 67.5479 41.0662 67.7171 40.7974 67.9635C40.5287 68.2099 40.3316 68.5244 40.227 68.8736C40.0259 69.5277 39.9639 70.2167 40.045 70.8962C40.1073 71.3624 40.3171 71.7964 40.6437 72.1348C40.9703 72.4732 41.3966 72.6983 41.8602 72.7772C42.9069 72.939 43.5744 72.5497 44.1811 71.3766L41.8703 71.2046L41.7692 69.8445C43.0384 69.9304 44.262 69.9759 45.4705 70.1276C45.6981 70.158 46.0824 70.6333 46.0369 70.8558C45.8599 71.6193 45.7132 72.494 45.2379 73.0654C44.1609 74.37 42.644 74.4812 41.1119 74.0312C39.5798 73.5812 38.8516 72.3221 38.6089 70.8052C38.5366 70.3021 38.5366 69.7913 38.6089 69.2883C39.0033 66.2241 41.9512 64.9144 44.5199 66.6538C44.8735 66.8802 45.1624 67.1944 45.3582 67.5657C45.5541 67.9371 45.6503 68.3529 45.6374 68.7725V68.7725Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9969 69.9913V74.5421H60.5205C60.5205 74.3145 60.4648 74.0364 60.4648 73.7988C60.4648 71.7256 60.4648 69.6525 60.4648 67.5793C60.4648 67.281 60.566 66.7501 60.6924 66.7248C61.0934 66.6436 61.5099 66.6932 61.8806 66.8664C62.1904 67.097 62.4444 67.3942 62.6239 67.7361C63.4583 68.9294 64.2825 70.1278 65.1117 71.3262L65.3494 71.2453V66.6945H66.7197V74.3499C65.8651 74.6836 65.2988 74.3499 64.8184 73.6319C63.9841 72.388 63.1094 71.1694 62.2548 69.9407L61.9969 69.9913Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4283 74.3648C69.4283 71.872 69.398 69.5005 69.4688 67.1341C69.4688 66.8509 69.9744 66.3908 70.3284 66.3453C71.1913 66.2273 72.0647 66.2053 72.9325 66.2796C73.4022 66.3189 73.8505 66.4937 74.2229 66.7827C74.5954 67.0717 74.876 67.4625 75.0309 67.9077C75.394 68.7444 75.5186 69.6652 75.391 70.5683C75.2634 71.4713 74.8885 72.3215 74.3078 73.0249C73.769 73.612 73.0631 74.0197 72.2852 74.1929C71.3406 74.3409 70.3839 74.3985 69.4283 74.3648V74.3648ZM70.92 67.7257V72.5597C71.361 72.7107 71.8371 72.7269 72.2874 72.6062C72.7377 72.4855 73.1418 72.2334 73.4482 71.8821C74.0449 71.0933 74.2067 69.1415 73.6757 68.3426C72.9982 67.3515 71.9616 67.7763 70.92 67.7257V67.7257Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8087 68.1453V74.5417L48.3828 74.4103V66.684C49.6671 66.684 50.9464 66.593 52.2105 66.7093C52.6417 66.7717 53.0419 66.9694 53.3536 67.2738C53.6653 67.5782 53.8723 67.9736 53.9449 68.4032C54.0932 68.8791 54.1044 69.3871 53.9775 69.8691C53.8505 70.3511 53.5904 70.7876 53.2269 71.1286C52.9943 71.3612 52.7212 71.5534 52.4229 71.8062C52.9286 72.7063 53.3988 73.5911 53.8893 74.4861C52.6808 74.8047 52.2358 74.6024 51.7403 73.581C51.3358 72.7467 50.911 71.9225 50.4762 71.0528C51.2498 70.4966 52.7314 70.5472 52.3572 69.0302C52.1903 68.2667 51.4167 68.0139 49.8087 68.1453Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5751 74.542H56.2402V66.8057H57.5751V74.542Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.22c0e7a07b0ad6fe998e8100fc1c8a87.svg";
export { ForwardRef as ReactComponent };